import { View } from 'react-native'

export function SidebarDivider() {
    return <View className="h-px mx-3 my-2 bg-border" />
}
